export interface ProgramOption {
  value: string;
  label: string;
}

interface ProgramDefinition extends ProgramOption {
  signupPlan: string;
}

const programs: readonly ProgramDefinition[] = [
  {value: 'Social Studies', label: 'Social Studies', signupPlan: 'social-studies'},
  {value: 'ELA', label: 'ELA', signupPlan: 'ela'},
  {value: 'Digital Citizenship', label: 'Digital Citizenship', signupPlan: 'digital-citizenship'},
];

export function getPrograms(): ProgramOption[] {
  return programs.map(({value, label}) => ({value, label}));
}

export function getProgramBySignupPlan(signupPlan: string | null): ProgramOption | null {
  const program = programs.find((option) => option.signupPlan === signupPlan);
  return program ? {value: program.value, label: program.label} : null;
}

const ProgramService = {
  getPrograms,
  getProgramBySignupPlan,
};

export default ProgramService;
